import React, { useMemo } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { DetailContextProvider } from "@/contexts/DetailContextProvider";
import {
  getPrimaryLinkedEntityKind,
  taskLinkedEntityToParentEntity,
  type TaskLinkedEntityKind,
} from "@/lib/utils/crm/task-linked-entity";
import type { Contact_Tasks } from "@/src/gql/graphql";

export function LinkedEntityContextShell({
  task,
  expectedKind,
  children,
}: {
  task: Contact_Tasks;
  expectedKind: TaskLinkedEntityKind;
  children: React.ReactNode;
}) {
  const kind = getPrimaryLinkedEntityKind(task);
  const parentEntity = useMemo(() => taskLinkedEntityToParentEntity(task), [task]);
  
  if (kind !== expectedKind || !parentEntity) {
    return (
      <Card>
        <CardContent className="py-8 text-center text-sm text-gray-600 dark:text-gray-400">
          This section applies when the task is linked to a {expectedKind.replace(/_/g, " ")} record.
        </CardContent>
      </Card>
    );
  }
  
  return <DetailContextProvider parentEntity={parentEntity}>{children}</DetailContextProvider>;
}
